import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import OnePageLayout from "../../components/layout/OnePageLayout";
import {
  Btns,
  ButtonL,
  ButtonXS,
  Content,
  FlexBox,
  InputsDiv,
  Section,
} from "../../styles/Common";
import { styled } from "styled-components";
import {
  Modal,
  ReturnContentModal,
  ReturnModal,
} from "../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/slices/authSlice";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";
import {
  autoHyphen,
  removeHyphen,
  returnParamsBirth,
  returnSubstrBirth,
} from "../../components/hooks/basicFunc";

const AddUserInfo = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const signUpInfoData = useSelector((state) => state.auth.signUpInfo);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [emailStatus, setEmailStatus] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openReturnModal, setOpenReturnModal] = useState(false);
  const [myInfo, setMyInfo] = useState({
    name: "" || signUpInfoData.name,
    phone: "" || autoHyphen(signUpInfoData.phone),
    yyyy: "" || returnSubstrBirth(signUpInfoData.birth, "yyyy"),
    mm: "" || returnSubstrBirth(signUpInfoData.birth, "mm"),
    dd: "" || returnSubstrBirth(signUpInfoData.birth, "dd"),
    email: "" || signUpInfoData.email,
  });
  const urls = process.env.REACT_APP_BASE_URL;
  //임시
  const [uid, setUid] = useState("");

  const modalMsg = useSelector((state) => state.auth.modalMsg);

  const sendEmailConfirmSuccess = useSelector(
    (state) => state.auth.sendEmailConfirmSuccess
  );
  const authCheckList = useSelector((state) => state.auth.authCheckList);
  const authCheckSuccessEmail = useSelector(
    (state) => state.auth.authCheckList.email
  );
  const authCheckSuccessPhone = useSelector(
    (state) => state.auth.authCheckList.phone
  );

  const emailRegEx =
    /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/i;
  const emailCheck = () => {
    return emailRegEx.test(myInfo.email); //형식에 맞을 경우, true 리턴
  };

  useEffect(() => {
    if (
      myInfo.name &&
      myInfo.phone &&
      myInfo.yyyy &&
      myInfo.yyyy.length == 4 &&
      myInfo.mm &&
      myInfo.dd &&
      myInfo.email &&
      emailCheck()
    ) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [myInfo]);

  useEffect(() => {
    // console.log("sendEmailCode", sendEmailConfirmSuccess, myInfo.email);
    if (sendEmailConfirmSuccess) {
      const timestamp = new Date().getTime();
      const params = {
        email: myInfo.email,
        timestamp: timestamp,
      };
      const loop = setInterval(() => {
        fetch(`${urls}/public/mail/url/verification`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ params }),
        })
          .then((response) => {
            if (response.ok && response.status == 200) {
              setEmailStatus(true);
              clearInterval(loop);
            } else {
              setEmailStatus(false);
            }
          })
          .catch((err) => console.log(err));
      }, 5000);

      return () => clearInterval(loop);
    }
  }, [sendEmailConfirmSuccess]);

  const handleSignUp = () => {
    if (!emailStatus) {
      setOpenReturnModal(true);
      return;
    }
    const params = {
      tid: signUpInfoData.tid,
      name: signUpInfoData.name,
      phone: signUpInfoData.phone,
      birth: signUpInfoData.birth,
      gender: signUpInfoData.gender,
      email: myInfo.email,
    };
    dispatch(authActions.setSignUpInfo(params));
    navigate("/sign-up/setting-password");
  };

  const maxLengthNumber = (e) => {
    const { name, value } = e.target;
    let res;
    if (value.length > e.target.maxLength) {
      res = value.slice(0, e.target.maxLength);
      setMyInfo((prev) => ({ ...prev, [name]: res }));
    } else {
      setMyInfo((prev) => ({ ...prev, [name]: value }));
    }
  };
  const checkSignUp = () => {
    if (authCheckSuccessPhone) {
      handleSignUp();
    } else {
      if (
        myInfo.yyyy <= 0 ||
        0 >= myInfo.mm ||
        12 < myInfo.mm ||
        0 >= myInfo.dd ||
        31 < myInfo.dd
      ) {
        dispatch(
          authActions.showMsg({
            type: "",
            msg: `생년월일을 재확인해주세요.`,
          })
        );
        return;
      } else if (!emailStatus) {
        setOpenReturnModal(true);
        return;
      } else {
        const params = {
          input: "phone", // (required) phone or email
          value: removeHyphen(myInfo.phone),
        };
        dispatch(authActions.fetchAuthCheck({ params }));
      }
    }
  };

  const checkSendEmail = () => {
    if (!emailCheck() || !myInfo.email) {
      dispatch(
        authActions.showMsg({
          type: "",
          msg: `이메일을 확인해주세요.`,
        })
      );
    } else {
      const params = {
        input: "email", // (required) phone or email
        value: myInfo.email,
      };
      dispatch(authActions.fetchAuthCheck({ params }));
    }
  };

  const handleSendEmail = () => {
    // console.log("이메일 보냄");
    const timestamp = new Date().getTime();

    const params = {
      email: myInfo.email,
      timestamp: timestamp,
    };
    dispatch(authActions.fetchSendEmailConfirm({ params }));
  };

  useEffect(() => {
    if (authCheckSuccessEmail) {
      handleSendEmail();
    }
  }, [authCheckSuccessEmail]);

  useDidMountEffect(() => {
    if (authCheckSuccessPhone) {
      handleSignUp();
    }
  }, [authCheckSuccessPhone]);

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);
  return (
    <OnePageLayout title="회원 정보 등록">
      {openModal && (
        <Modal setOpenModal={setOpenModal}>
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      {openReturnModal && (
        <ReturnContentModal setOpenModal={setOpenReturnModal}>
          <p>
            이메일 인증이 완료되지 않았습니다. 계속 진행하기 위해서는 해당
            이메일 주소로 발송된 인증 링크를 클릭해주셔야 합니다.
          </p>
        </ReturnContentModal>
      )}
      <Section>
        <Content>
          <InputsDiv>
            <div>
              <h3>이름</h3>
              <input
                readOnly
                type="text"
                placeholder="이름을 입력하세요."
                name="name"
                value={myInfo.name || ""}
                onChange={(e) => {
                  setMyInfo((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
            </div>
            <PhoneNumInput>
              <h3>휴대폰</h3>
              <input
                readOnly
                type="tel"
                maxLength={13}
                placeholder="휴대폰 번호를 입력하세요."
                name="phone"
                value={myInfo.phone || ""}
                onChange={(e) => {
                  return;
                }}
              />
            </PhoneNumInput>
            <BirthInput>
              <h3>생년월일</h3>
              <InputFlexbox>
                <input
                  readOnly
                  type="number"
                  maxLength={4}
                  placeholder="0000"
                  className="yyyy"
                  name="yyyy"
                  value={myInfo.yyyy || ""}
                  onChange={(e) => {
                    maxLengthNumber(e);
                  }}
                />{" "}
                년
                <input
                  readOnly
                  type="number"
                  maxLength={2}
                  placeholder="00"
                  className="mm"
                  name="mm"
                  value={myInfo.mm || ""}
                  onChange={(e) => {
                    maxLengthNumber(e);
                  }}
                />{" "}
                월
                <input
                  readOnly
                  type="number"
                  maxLength={2}
                  placeholder="00"
                  className="dd"
                  name="dd"
                  value={myInfo.dd || ""}
                  onChange={(e) => {
                    maxLengthNumber(e);
                  }}
                />{" "}
                일
              </InputFlexbox>
            </BirthInput>
            <div>
              <h3>이메일 주소 입력(로그인 아이디)</h3>
              <InputFlexbox>
                <input
                  disabled={emailStatus}
                  className="emailInput"
                  type="email"
                  name="email"
                  value={myInfo.email || ""}
                  onChange={(e) => {
                    setMyInfo((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }));
                  }}
                  placeholder="예 : honggd@gmail.com"
                />
                <ButtonXS
                  col="purple_light"
                  onClick={
                    emailStatus
                      ? () => {
                          return;
                        }
                      : () => {
                          checkSendEmail();
                        }
                  }
                >
                  {emailStatus ? "인증 완료" : "인증 메일 발송"}
                </ButtonXS>
              </InputFlexbox>
              {sendEmailConfirmSuccess && (
                <EmailInfo>
                  입력하신 이메일 주소로 인증 메일을 발송하였습니다.
                  <br />
                  이메일 주소를 확인하여 이메일 인증하기 버튼을 클릭해 주세요.
                  <br />
                  인증하기 버튼 클릭후 다음으로 진행해주세요.
                </EmailInfo>
              )}
            </div>
          </InputsDiv>
        </Content>
        <Btns>
          <ButtonL
            disabled={btnDisabled}
            onClick={() => {
              checkSignUp();
            }}
          >
            다음
          </ButtonL>
        </Btns>
      </Section>
    </OnePageLayout>
  );
};

export default AddUserInfo;
const InputFlexbox = styled(FlexBox)`
  .yyyy {
  }
  .mm,
  .dd {
    margin-left: 3rem;
  }
  .emailInput {
    width: calc(100% - 14rem);
    margin-right: 2rem;
    &:disabled {
      color: ${({ theme }) => theme.color.input_text_gray};
    }
  }
`;
const EmailInfo = styled.p`
  color: ${({ theme }) => theme.color.purple_second};
  font-size: 1.4rem;
  line-height: 1.4rem; /* 100% */
  margin-top: 1rem;
`;
const PhoneNumInput = styled.div`
  display: none;
`;
const BirthInput = styled.div`
  display: none;
`;
